import {
    Button,
    dispatchCustomEvent,
    Flexer,
    Footer,
    FormHelperText,
    Input,
    InputControl,
    InputPrefix,
    Label,
    Stack,
    useInput,
} from '@fold-dev/core'
import { useMemo, useState } from 'react'
import { ColorButton, CommonProvider, Error, Loading, UserSelect } from '../../components'
import { COLORS } from '../../constants'
import { useAppStore } from '../../store/app'
import { useProjectUsers, useWorkspaceUsers } from '../../hooks/api.hooks'
import { useParams } from 'react-router'

export const CreateConversation = ({ onBack, onCreate, noBack = false }) => {
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState<any>(null)
    const [availableUsers, setAvailableUsers] = useState<any>([])
    const [existingUsers, setExistingUsers] = useState([])
    const [users, setUsers] = useState<any>([])
    const workspaceUsersAPI = useWorkspaceUsers()
    const { workspaceId } = useParams()
    const workspace = useAppStore((state) => state.workspace)
    const projects = useAppStore((state) => state.projects)

    const handleCreate = () => {
        onCreate({ users })
    }

    const handleUserAdd = (user) => {
        setUsers([...users, user])
    }

    const handleUserDelete = (user) => {
        setUsers(users.filter((u) => u.id != user.id))
    }

    const handleUserFilter = async (query = '') => {
        setError(null)

        try {
            const users = await workspaceUsersAPI.getSearch(workspaceId, query)

            setAvailableUsers(users.filter((user) => !existingUsers.includes(user.id)))
        } catch (e) {
            setError(typeof e == 'string' ? e : 'An error occured')
        }
    }

    return (
        <div>
            <Stack
                p="1rem"
                width="100%"
                direction="vertical"
                spacing="0.75rem">
                <Label
                    fontWeight={600}
                    size="sm">
                    Add people
                </Label>

                <Error error={error} />
                <Loading loading={loading} />

                <Stack
                    direction="vertical"
                    spacing={15}>
                    <CommonProvider
                        onUserFilter={handleUserFilter}
                        onLabelFilter={(label) => null}
                        availableLabels={[]}
                        availableUsers={availableUsers}
                        colors={COLORS}>
                        <UserSelect
                            hideMe
                            users={users}
                            onAdd={handleUserAdd}
                            onDelete={handleUserDelete}
                            width="100%"
                            variant="default"
                            onOpen={handleUserFilter}
                        />
                    </CommonProvider>
                    <FormHelperText colorToken="text-weakest">You are able to add up to 8 users</FormHelperText>
                </Stack>
            </Stack>

            <Footer
                p="0.5rem"
                bg="transparent">
                {!noBack && (
                    <Button
                        size="sm"
                        onClick={onBack}>
                        Back
                    </Button>
                )}
                <Flexer />
                <Button
                    onClick={handleCreate}
                    variant="accent"
                    size="sm"
                    disabled={!users.length || users.length > 8}>
                    Create
                </Button>
            </Footer>
        </div>
    )
}
